<template>
  <div>
    <custom-popup
      v-model="showInfo"
      :cons="{ title: 'اطلاعات بیشتر' }"
      hide-confirm
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <v-card flat>
        <v-card-text>
          <div class="pa-12">
            <div class="py-2 border-bottom my-2">
              <p class="d-block text-dark" style="font-size: 10pt">
                عنوان آگهی :
              </p>
              <p v-if="item.advertise" class="mr-3" style="font-size: 9pt">
                {{ item.advertise.post.title }}
              </p>
            </div>
            <div class="py-2 border-bottom my-2">
              <p class="d-block text-dark" style="font-size: 10pt">
                توضیحات آگهی :
              </p>
              <p v-if="item.advertise" class="mr-3" style="font-size: 9pt">
                {{ item.advertise.post.description }}
              </p>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </custom-popup>

    <v-speed-dial v-model="fab" direction="right" left>
      <template v-slot:activator>
        <v-btn v-model="fab" icon>
          <v-icon v-if="!fab">mdi-dots-vertical</v-icon>
          <v-icon v-else>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-tooltip v-if="!isPast" top>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            color="red"
            dark
            fab
            small
            v-bind="attr"
            @click="clickRefund"
            v-on="on"
          >
            <v-icon>mdi-cash-refund</v-icon>
          </v-btn>
        </template>

        <span>لغو پرداخت</span>
      </v-tooltip>

      <v-tooltip v-if="item.advertise" top>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            :href="`https://divar.ir/s/${item.advertise.data.token}`"
            color="#8950fc"
            dark
            fab
            small
            target="_blank"
            v-bind="attr"
            v-on="on"
          >
            <v-icon>mdi-note</v-icon>
          </v-btn>
        </template>

        <span>آگهی من در دیوار</span>
      </v-tooltip>

      <v-tooltip top>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            color="info"
            fab
            small
            v-bind="attr"
            @click="showInfo = true"
            v-on="on"
          >
            <v-icon>mdi-information</v-icon>
          </v-btn>
        </template>

        <span>اطلاعات بیشتر</span>
      </v-tooltip>
    </v-speed-dial>
  </div>
</template>

<script>
import { Axios2 } from "@/main";

export default {
  name: "payListButtons",

  props: {
    item: Object,
  },

  data: () => ({
    fab: false,
    showInfo: false,
    loading: false,
  }),

  computed: {
    isPast() {
      const moment = require("moment");
      return moment().isAfter(this.item.available_at);
    },
  },

  methods: {
    async clickRefund() {
      if (await this.$modal.yesNo("تایید لغو پرداخت")) this.refund();
    },
    refund() {
      this.loading = true;

      Axios2.delete(`/payment/${this.item.id}`)
        .then(({ data }) => {
          this.$toast.success("برداخت با موفقیت لغو شد.");
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در لغو پرداخت!");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
